import { render, staticRenderFns } from "./MyTeamList.vue?vue&type=template&id=efbf6812&scoped=true&"
import script from "./MyTeamList.vue?vue&type=script&lang=js&"
export * from "./MyTeamList.vue?vue&type=script&lang=js&"
import style0 from "./MyTeamList.vue?vue&type=style&index=0&id=efbf6812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbf6812",
  null
  
)

export default component.exports